import { useEffect } from 'react';
import './App.css';
import Layout from './Components/Layout/Layout';
import { useNavigate } from 'react-router-dom';
import IdleTimer from './Auth/IdleTimer';
// import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
    let Navigate = useNavigate();
    const token = localStorage.getItem('token');
    const logoutHandler = () => {
        try {
            localStorage.clear();
            Navigate('/login');
            window.location.reload();
        } catch (error) {
            console.error('Error clearing localStorage:', error);
        }
    };

    if ('serviceWorker' in navigator) {
        window.addEventListener('load', () => {
            navigator.serviceWorker.register('/service-worker.js').then(
                (registration) => {
                    console.log(
                        'ServiceWorker registration successful with scope: ',
                        registration.scope
                    );
                },
                (err) => {
                    console.log('ServiceWorker registration failed: ', err);
                }
            );
        });
    }

    useEffect(() => {
        let token = localStorage.getItem('token');
        if (!token) {
            localStorage.clear();
            Navigate('/login');
        }
        // eslint-disable-next-line
    }, []);
    return (
        <div>
            {token && (
                <>
                    <Layout />
                    <IdleTimer logoutHandler={logoutHandler} />
                </>
            )}
        </div>
    );
}

export default App;
